/**
 * Seeded PRNG (Mulberry32) as immutable values: every draw returns the next
 * state instead of mutating, so a sim step never has hidden side effects.
 */

/** @typedef {{ s: number }} Rng */

/** @returns {Rng} */
export function rngFrom(seed) {
  return { s: seed | 0 };
}

/** @returns {{ value: number, rng: Rng }} value in [0, 1) */
export function nextFloat(rng) {
  const s = (rng.s + 0x6d2b79f5) | 0;
  let t = Math.imul(s ^ (s >>> 15), 1 | s);
  t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
  return { value: ((t ^ (t >>> 14)) >>> 0) / 4294967296, rng: { s } };
}

/** @returns {{ value: number, rng: Rng }} integer in [0, n) */
export function nextInt(rng, n) {
  const out = nextFloat(rng);
  return { value: Math.floor(out.value * n), rng: out.rng };
}

/**
 * Independent seed per purpose, so e.g. hazard draws never shift tile placement.
 * FNV-1a over the purpose name mixed with the run seed.
 */
export function deriveSeed(seed, purpose) {
  let h = 0x811c9dc5 ^ (seed | 0);
  for (let i = 0; i < purpose.length; i++) {
    h ^= purpose.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h | 0;
}
